import React, { useEffect } from "react";
import "../assets/css/Message.css"
import $ from "jquery"

export enum MessageType{
    SUCCESS,//SUCCESS;
    WARNING,//WARNING;
    CRITICAL,//CRITICAL;
}

export interface MessageProps{
    content: any;
    type: MessageType;
    callback?: () => void;
}

const Message = (
    {content, type, callback}: MessageProps
) =>{
    useEffect(() => {
        const $message = $('.message');
        const initialTop = parseInt($message.css('top'), 0);

        const show = () => {
            $message.animate({ top: `${initialTop + 20}px` });
        };
        const hide = () => {
            $message.delay(7000).animate({ top: `${initialTop}px`, opacity: 0 }, () => {
                if (callback) callback();
            });
        };

        show();
        hide();
        return () => {
            $message.stop(true, true);
        };
    }, [content, callback])
    return (
    <div className="message">
        <div className="gradient-bg">
            <p style={{color: type === MessageType.CRITICAL ? 'red' : type === MessageType.WARNING ? 'orange' : 'white'}} dangerouslySetInnerHTML={{__html: content}}></p>
        </div>
    </div>)
}

export default Message